module.exports = __webpack_public_path__ + "static/img/ffff4@2x.60dd5df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ffff4@2x.png
// module id = Bo9J
// module chunks = 3